import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/admin/users").then((r) => setUsers(r.data)); }, []);

  return (
    <div>
      <h1 className="font-display font-black text-3xl tracking-tight mb-6">USUARIOS</h1>
      <div className="border border-border overflow-x-auto" data-testid="admin-users-table">
        <table className="w-full text-sm">
          <thead className="bg-secondary text-left"><tr>
            <th className="p-3 font-semibold">Nombre</th><th className="p-3 font-semibold">Correo</th><th className="p-3 font-semibold">Rol</th><th className="p-3 font-semibold">Empresa</th><th className="p-3 font-semibold">Acceso</th><th className="p-3 font-semibold">Registro</th>
          </tr></thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.user_id} className="border-t border-border">
                <td className="p-3 font-medium">{u.name}</td>
                <td className="p-3">{u.email}</td>
                <td className="p-3"><span className={`text-xs font-semibold px-2 py-1 border ${u.role === "admin" ? "bg-brand/15 text-brand border-brand/30" : "border-border"}`}>{u.role}</span></td>
                <td className="p-3">{u.company || "-"}</td>
                <td className="p-3 capitalize">{u.auth_provider || "password"}</td>
                <td className="p-3 text-muted-foreground">{u.created_at ? new Date(u.created_at).toLocaleDateString() : "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
